import { Injectable } from '@angular/core';

import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SessionStorageService } from 'ngx-webstorage';

@Injectable()
export class AppGuardService {

  constructor(private router: Router, private sessionStorage: SessionStorageService) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return true;
  }
  public getToken() {
    return this.sessionStorage.retrieve('zest-application');
  }
  checkApplication(): boolean {
    if (this.getToken() !== null) { return true; }
    this.router.navigate(['/']);
    return false;
  }
}
